var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M3.8.9a.6.6 0 0 0-.6.6v9a.6.6 0 0 0 .6.6h5.4a.6.6 0 0 0 .6-.6v-9a.6.6 0 0 0-.6-.6zm5.1 1.5H4.1v7.2h4.8z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPhone;